let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Eh3Y")).then(() => parcelRequire('gkDnC'));